import { TAG_CODES } from "../../tag.config"

const GOM_ACTION_AERIAL_OFFENSIVE = {
    type: 'path',
    tagCode: TAG_CODES.ACTION,
    withText: true,
    defaultText: 'Aerial offensive',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'water',
    withFillColor: false,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M105 77A30 30 0 11103 23M133 75A30 30 0 11134 25M120 50A30 30 0 11120 51`,
}

export default GOM_ACTION_AERIAL_OFFENSIVE